import { TeachersUIFilters } from '../../types/TeachersUIFilters';

export function mergeTeacherFiltersIntoSearchParams(
  current: URLSearchParams,
  filters: TeachersUIFilters
): URLSearchParams {
  const newParams = new URLSearchParams(current.toString());

  if (filters.modality) {
    newParams.set('modality', filters.modality);
  } else {
    newParams.delete('modality');
  }

  if (filters.availability) {
    newParams.set('availability', filters.availability);
  } else {
    newParams.delete('availability');
  }

  if (filters.timeRanges?.length) {
    newParams.set('timeRange', filters.timeRanges.join(','));
  } else {
    newParams.delete('timeRange');
  }

  if (filters.daysOfWeek?.length) {
    newParams.set('daysOfWeek', filters.daysOfWeek.join(','));
  } else {
    newParams.delete('daysOfWeek');
  }

  if (filters.minPricePerHour != null) {
    newParams.set('minPricePerHour', String(filters.minPricePerHour));
  } else {
    newParams.delete('minPricePerHour');
  }

  if (filters.maxPricePerHour != null) {
    newParams.set('maxPricePerHour', String(filters.maxPricePerHour));
  } else {
    newParams.delete('maxPricePerHour');
  }

  return newParams;
}
